/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Fragment } from 'react'
import { CidadaoListagemPessoaIdosaQueryModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/model-acompanhamentoCondicaoSaudeListaTematica'

import { AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionPanel } from '../AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionPanel'
import { AcompanhamentoCondicaoSaudeIvcfAccordionPanel } from './AcompanhamentoCondicaoSaudeIvcfAccordionPanel'
import { AcompanhamentoCondicaoSaudeMedicoesPessoaIdosaAccordionPanel } from './AcompanhamentoCondicaoSaudeMedicoesPessoaIdosaAccordionPanel'

interface AcompanhamentoCondicaoSaudePessoaIdosaAccordionSectionProps {
  row: CidadaoListagemPessoaIdosaQueryModel
}

export function AcompanhamentoCondicaoSaudePessoaIdosaAccordionSection({
  row,
}: Readonly<AcompanhamentoCondicaoSaudePessoaIdosaAccordionSectionProps>) {
  return (
    <Fragment>
      <AcompanhamentoCondicaoSaudeIvcfAccordionPanel
        riscoVulnerabilidade={row?.ivcf?.riscoVulnerabilidade}
        dataRegistro={row?.ivcf?.dataResultado}
        subgrupos={row?.ivcf?.subgrupo}
      />
      <AcompanhamentoCondicaoSaudeMedicoesPessoaIdosaAccordionPanel
        quantidadeMedicoesPesoAlturaSimultaneos={
          row?.cidadao?.cidadaoConsolidado?.pessoaIdosa?.quantidadeMedicoesSimultaneasPesoAltura
        }
      />
      <AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionPanel
        dataUltimasVisitasDomiciliares={
          row?.cidadao?.cidadaoConsolidado?.visitaDomiciliar?.dataUltimasVisitasDomiciliares
        }
        qtdVisitasDomiciliares={row?.cidadao?.cidadaoConsolidado?.visitaDomiciliar?.qtdVisitasDomiciliares}
      />
    </Fragment>
  )
}
